<template>
    <section class="content">
      <!-- <keep-alive> -->
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br />
        <h4>Loading...</h4>
      </div>
      <div>
        <div class="box box-info">
              <DataTable :value="salesInvoiceUnpaidLists" :paginator="true" ref="po" :rows="100" :filters="filters" editMode="cell"
                :rowsPerPageOptions="[100, 500, 1000]" class="p-datatable-responsive p-datatable-gridlines" data-key="id"
                :selection.sync="selectedProduct1" selectionMode="single">
                <Column header="S.N">
                  <template #body="sl">
                    {{ sl.index + 1 }}
                  </template>
                </Column>
                <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']" />
                  </template>
                </Column>
                <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']" />
                  </template>
                </Column>
                <Column header="Bill No" :sortable="true" field="billNo" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['billNo']" />
                  </template>
                </Column>
                <Column header="Customer" :sortable="true" field="accountName" filterMatchMode="contains">
                  <template #body="slotProps">
                    {{ slotProps.data.accountMaster.name }}
                  </template>
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
                  </template>
                  <template #footer>
                    Total:
                  </template>
                </Column>
                <Column header="contactNumber" headerStyle="width:8em;" :sortable="true" field="contactNumber"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
                  </template>
                </Column>
                <Column header="Account contact Name" headerStyle="width:8em;" :sortable="true" field="accountContactPerson"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['accountContactPerson']" />
                  </template>
                </Column>

                <Column header="Account Contact Number" headerStyle="width:8em;" :sortable="true" field="accountContactNumber"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['accountContactNumber']" />
                  </template>
                </Column>
                <Column header="Remarks"  >
                  <template #body="slotProps">
                    <Button class="p-button-raised p-button-warning" v-tooltip.top="'View Remarks'"
                      @click="showMessageDialog(slotProps.data)" ><span class="pi pi-envelope"></span></Button>
                  </template>
                </Column>
               
                <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['address']" />
                  </template>
                </Column>
                <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']" />
                  </template>
                </Column>
            
                <Column header="Total" bodyStyle="text-align: right" field="totalBillAmount" :sortable="true"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']" />
                  </template>
                  <template #footer>
                    {{ totalSumBillAmount.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Pay status" bodyStyle="text-align: right" field="paymentStatus" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['paymentStatus']"/>
                </template>
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data['paymentStatus']" :options="statusesPay"
                            @change="updatePaymentStatus(slotProps.data)"
                            optionLabel="label" optionValue="value" placeholder="Select a Status">
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template>
                  </Dropdown>
                </template>
                <template #body="slotProps">
                  {{ getPayStatusLabel(slotProps.data.paymentStatus) }}
                </template>
              </Column>
              <Column header="Pay Method" bodyStyle="text-align: right" field="paymentMethod" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['paymentMethod']"/>
                </template>
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data['paymentMethod']" :options="payMethod"
                            @change="updatePaymentStatus(slotProps.data)"
                            optionLabel="label" optionValue="value" placeholder="Select a Status">
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template>
                  </Dropdown>
                </template>
                <template #body="slotProps">
                  {{ getPaymentMethodLabel(slotProps.data.paymentMethod) }}
                </template>
              </Column>
              <Column header="Cheque Date" headerStyle="width:8em;" :sortable="true" field="chequeDate"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['chequeDate']" />
                </template>
                <template #body="slotProps">
                  {{ formatChequeDate(slotProps.data.chequeDate) }}
                </template>
              </Column>
              <Column header="Org Name" :sortable="true" field="organisationName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['organisationName']"/>
                </template>
              </Column>
              <Column header="Action" headerStyle="width:12em">
                  <template #body="slotProps">
                    <Button icon="pi pi-eye" class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                      @click="viewPIVDetail(slotProps.data)" />
                  </template>
                </Column>
             
                <template #empty>No record found</template>
              </DataTable>
            <!-- </div>
          </div> -->
        </div>
      </div>
      <Dialog
        :visible="receivedMessageDialog"
        :style="{ width: '500px' }"
        :modal="true"
        class="p-fluid"
        @show="checkNepaliDateOrEnglish"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="remarks">Remarks <span style="color:red">*</span></label>
            <Textarea
              id="remarks"
              v-model="paymentRemarks"
              rows="12"
              autoResize
            />
            <small style="color: #e74c3c; font-style: italic; display: block; margin-top: 4px;">
              For date in remarks, enter in format like <strong>2082-04-29</strong>, not 2082/04/29
            </small>
          </div>
          <div class="p-col-12 p-md-6">
            <div class="p-grid">
              <div class="p-field p-col-6">
                <label>Next Follow-up Date</label>
                <date-picker
                  v-model="nextFollowUpDate"
                  valueType="format"
                  v-if="!englishDateEnabled"
                />
                <input-mask
                  mask="9999-99-99"
                  class="nepali-calendar"
                  id="nextFollowUpDate"
                  v-model="nextFollowUpDate"
                  v-else
                />
              </div>
              <div class="p-field p-col-6">
                <label>Cheque Date</label>
                <date-picker
                  v-model="chequeDate"
                  valueType="format"
                  v-if="!englishDateEnabled"
                />
                <input-mask
                  mask="9999-99-99"
                  class="nepali-calendar"
                  id="chequeDate"
                  v-model="chequeDate"
                  v-else
                />
              </div>
              <div class="p-field p-col-6">
                <label>Follow-up Time</label>
                <Calendar 
                  id="followUpTime" 
                  v-model="followUpTime" 
                  :timeOnly="true" 
                  :hourFormat="'24'"
                  :showIcon="true"
                  :stepMinute="5"
                  placeholder="Select Time"
                />
              </div>
              <div class="p-col-6"></div>
            </div>
          </div>
        </div>
        <template #footer>
          <Button
            label="Save"
            icon="pi pi-check"
            class="p-button p-button-raised p-button-primary"
            @click="updatePaymentRemarks"
          />
          <Button
            label="Cancel"
            icon="pi pi-times"
            class="p-button p-button-raised p-button-danger"
            @click="closeDialog"
          />
        </template>
      </Dialog>
      <!-- <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport" /> -->
    </section>
  </template>
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  // import Dialog from '../../layout/dialog'
  import globalKey from '../../../store/globalKey'
  import axios from 'axios'
  import $ from 'jquery'
  import InputText from 'primevue/inputtext'
  import Calendar from 'primevue/calendar/Calendar'
  import Button from 'primevue/button'
  import InputMask from 'primevue/inputmask'
  import Dropdown from 'primevue/dropdown'
  import Dialog from 'primevue/dialog/Dialog'
  import Textarea from 'primevue/textarea/Textarea'
  export default {
    name: 'salesInvoiceTodayUnpaidReport',
    props: ['status'],
    data() {
      return {
        fromDate: null,
        toDate: null,
        paymentRemarks: '',
        nextFollowUpDate: null,
        followUpTime: null,
        chequeDate: null,
        receivedMessageDialog: false,
        loading: false,
        dialogShow: false,
        columnList: '',
        filters: {},
        englishDateEnabled: true,
        selectedProduct1: null,
        enableEdit: false,
        enableDelete: false,
        totalSubAmount: 0,
        totalNonTaxableAmount: 0,
        totalTaxableAmount: 0,
        totalVatAmount: 0,
        totalSumBillAmount: 0,
        totalDiscountAmount: 0,
        statusesPay: [{label: 'Paid', value: 'Paid'}, {label: 'Unpaid', value: 'Unpaid'}],
        payMethod: [{label: 'Cash', value: 'CASH'}, {label: 'Esewa', value: 'ESEWA'}, {label: 'Prabhu Bank', value: 'PRABHU'}, {label: 'Nic Bank', value: 'NIC'}]
      }
    },
    computed: {
      salesInvoiceUnpaidLists() {
        return this.$store.state.sales.salesInvoiceTodayUnpaidLists
      }
    },
    mounted() {
      if (this.status !== undefined) {
        this.$toast.add({ severity: 'success', summary: '', detail: this.status.message, life: 3000 })
      }
      this.salesInvoiceUnpaidList()
      // this.checkEnglish()
      // if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      //   this.nepaliDate()
      // }
      // if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      //   this.$store.state.isEnglishDateEnabled === 'false') {
      //   this.setNepaliDate()
      // }
      // if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      //   this.setEnglishDate()
      // }
      this.columnNames()
      // this.checkEnableEdit()
      // this.checkEnableDelete()
    },
    methods: {
      async searchUnpaidInvoice() {
        this.loading = !this.loading
        let resp = await this.$store.dispatch('loadSalesInvoiceUnPaidTodayLists')
        this.loading = false
        if (resp.data.data.length <= 0) {
          this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 3000 })
        } else {
          this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 3000 })
          // this.totalBalance()
        }
      },
      async viewPIVDetail(data) {
        let PIHdata = {
          id: data.id,
          warehouse: data.warehouse,
          account: data.accountMaster,
          salesDate: data.purchaseSalesDateNepali,
          billNo: data.billNo,
          reportType: data.reportType,
          referenceNumber: data.referenceNumber,
          subTotalAmount: data.subTotalAmount,
          nonTaxableAmount: data.nonTaxableAmount,
          taxableAmount: data.taxableAmount,
          vatAmount: data.vatAmount,
          totalBillAmount: data.totalBillAmount,
          vatTypeEnum: data.vatTypeEnum,
          exciseChargeAmount: data.exciseChargeAmount,
          discountAmt: data.discount,
          remarks: data.remarks
        }
        if (data.purchaseType !== 'dairy') {
          this.$router.push({ name: 'sales Detail Report', params: { salesHeaderObj: PIHdata } })
        } else {
          this.$router.push({ name: 'sales Detail Dairy Report', params: { purchaseHeaderObj: PIHdata } })
        }
      },
      formatChequeDate(dateString) {
        if (!dateString || dateString.trim() === '') {
          return 'NA'
        }
        const datePart = dateString.split('T')[0]
        return datePart
      },
      exportCSV() {
        let data = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          columnList: this.columnList
        }
        axios({
          url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/salesInvoice' + '/' + this.$store.getters.fyId + '/' + data.columnList,
          method: 'get',
          headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
          const link = document.createElement('a')
          const contentDisposition = response.headers['content-disposition']
          let fileName = 'salesInvoice.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1]
            }
          }
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
      },
      async salesInvoiceUnpaidList() {
        await this.$store.dispatch('loadSalesInvoiceUnPaidTodayLists')
        this.totalBalance()
      },
      exportToPdf(SOHeaderId) {
        axios({
          url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
          method: 'get',
          headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
          const link = document.createElement('a')
          const contentDisposition = response.headers['Content-Disposition']
          let fileName = 'salesInvoice.pdf'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1]
            }
          }
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
      },
      async updatePaymentStatus(data) {
        let payment = {
          id: data.id,
          status: data.paymentStatus,
          method: data.paymentMethod
        }
        let response = await this.$store.dispatch('paymentSalesStatusUpdate', payment)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: '',
            detail: 'Payment Status' + response.data.message,
            life: 3000
          })
        }
      },
      showMessageDialog(data) {
        this.paymentRemarks = data.paymentRemarks
        this.nextFollowUpDate = data.nextFollowUpDate
        this.followUpTime = data.followUpTime
        this.chequeDate = data.chequeDate
        this.id = data.id
        this.receivedMessageDialog = true
      },
      closeDialog() {
        this.paymentRemarks = ''
        this.nextFollowUpDate = null
        this.chequeDate = null
        this.followUpTime = null
        this.receivedMessageDialog = false
      },
      async updatePaymentRemarks() {
        if (!this.paymentRemarks || this.paymentRemarks.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Remarks cannot be empty!', life: 10000})
          return
        }
        let payment = {
          id: this.id,
          remarks: this.paymentRemarks,
          followUpDate: this.nextFollowUpDate,
          chequeDate: this.chequeDate,
          followUpTime: this.cleanTimeFormat(this.followUpTime)
        }
        let response = await this.$store.dispatch('paymentSalesRemarksAndDate', payment)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: '',
            detail: 'Payment Status' + response.data.message,
            life: 3000
          })
          this.receivedMessageDialog = false
          await this.salesInvoiceUnpaidList()
        }
      },
      getPaymentMethodLabel(payMethod) {
        switch (payMethod) {
          case 'ESEWA':
            return 'Esewa'
          case 'CASH':
            return 'Cash'
          case 'PRABHU BANK':
            return 'prabhu'
          case 'NIC BANK':
            return 'nic'
          default:
            return 'NA'
        }
      },
      getPayStatusLabel(payStatus) {
        switch (payStatus) {
          case 'Paid':
            return 'Paid'

          case 'Unpaid':
            return 'Unpaid'

          default:
            return 'NA'
        }
      },
      cleanTimeFormat(time) {
        if (!time) return null
        if (time instanceof Date) {
          const hours = String(time.getHours()).padStart(2, '0')
          const minutes = String(time.getMinutes()).padStart(2, '0')
          return `${hours}:${minutes}`
        }
        if (typeof time === 'string' && time.includes(':')) {
          const parts = time.split(':')
          if (parts.length >= 2) {
            return `${parts[0]}:${parts[1]}`
          }
        }
        return time
      },
      columnNames() {
        for (let i = 0; i < this.$refs.po.columns.length; i++) {
          this.columnList += this.$refs.po.columns[i].header + ','
        }
      },
      checkEnableEdit() {
        if (this.$store.getters.modules.includes(',5.08')) {
          this.enableEdit = true
        }
      },
      checkEnableDelete() {
        if (this.$store.getters.modules.includes(',5.13')) {
          this.enableDelete = true
        }
      },
      totalBalance() {
        this.totalSubAmount = 0.0
        this.totalNonTaxableAmount = 0.0
        this.totalTaxableAmount = 0.0
        this.totalVatAmount = 0.0
        this.totalSumBillAmount = 0.0
        this.totalDiscountAmount = 0.0
        for (let sale of this.salesInvoiceUnpaidLists) {
          this.totalSubAmount += sale.subTotalAmount
          this.totalNonTaxableAmount += sale.nonTaxableAmount
          this.totalTaxableAmount += sale.taxableAmount
          this.totalVatAmount += sale.vatAmount
          this.totalSumBillAmount += sale.totalBillAmount
          this.totalDiscountAmount += sale.discount
        }
      },
      async editSalesInvoice(data) {
        this.$router.push({ name: 'Sales Invoice', params: { salesInvoice: data } })
      },
      async deleteReport(value) {
        if (value.trim() === '') {
          this.$toast.add({ severity: 'success', summary: '', detail: 'Delete reason cannot be empty!', life: 10000 })
          this.dialogShow = true
          return
        }
        let deleteRe = {
          inventoryOutHeaderId: this.accountId,
          deleteReason: value
        }
        let resp = await this.$store.dispatch('deleteSalesInvoice', deleteRe)
        if (resp.status === 'SUCCESS') {
          this.$toast.add({ severity: 'success', summary: '', detail: resp.message, life: 10000 })
        } else {
          this.$toast.add({ severity: 'error', summary: '', detail: resp.message, life: 10000 })
        }
        this.dialogShow = false
      },
      setEnglishDate() {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      reset() {
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.setNepaliDate()
        } else {
          this.setEnglishDate()
        }
      },
      cancel(data) {
        this.dialogShow = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      setNepaliDate() {
        if (this.nextFollowUpDate === '') {
          this.nextFollowUpDate = this.$store.getters.nepaliNewDate
        }
        // if (this.chequeDate === '') {
        //   this.chequeDate = this.$store.getters.nepaliNewDate
        // }
      },
      setEnglishDateFollowUp() {
        this.nextFollowUpDate = new Date().toISOString().slice(0, 10)
       // this.chequeDate = new Date().toISOString().slice(0, 10)
      },
      checkNepaliDateOrEnglish() {
        this.checkEnglish()
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.nepaliDate()
        }
        if (!this.$store.getters.englishDate ||
          this.$store.state.isEnglishDateEnabled === 'false') {
          this.setNepaliDate()
        }
        if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
          this.setEnglishDateFollowUp()
        }
      },
      nepaliDate() {
        this.$nextTick(() => {
          const element = document.getElementById('nextFollowUpDate')
          if (element) {
            $(element).nepaliDatePicker({
              ndpYear: true,
              ndpMonth: true,
              ndpYearCount: 10,
              disableBefore: this.$store.state.startDate,
              disableAfter: this.$store.state.endDate,
              onChange: () => {
                this.nextFollowUpDate = $('#nextFollowUpDate').val()
              }
            })
          }
          const chequeEl = document.getElementById('chequeDate')
          if (chequeEl) {
            $(chequeEl).nepaliDatePicker({
              ndpYear: true,
              ndpMonth: true,
              ndpYearCount: 10,
              disableBefore: this.$store.state.startDate,
              disableAfter: this.$store.state.endDate,
              onChange: () => {
                this.chequeDate = $('#chequeDate').val()
              }
            })
          }
        })
      }
    },
    components: {
      DatePicker,
      DataTable,
      Column,
      Dialog,
      InputText,
      Button,
      InputMask,
      Calendar,
      Textarea,
      Dropdown
    }
  }
  </script>
  <style scoped src="@../../../static/css/purchase.css">
  </style>
  



// WEBPACK FOOTER //
// salesInvoiceTodayUnpaidReport.vue?966b2e9e